// test1232
(1232 && 0);
